module.exports = __webpack_public_path__ + "static/media/last-added-cars-blurred.bb4a30a6.png";